import ProfilePage from '@/views/profile/ProfilePage.vue';

export const profileRoutes = [
  {
    path: '/profile',
    name: 'profile',
    component: ProfilePage,
    meta: { requiresAuth: true, type: 'profile' },
  },
  {
    path: '/profile/common-info',
    name: 'profile-common-info',
    component: ProfilePage,
    meta: { requiresAuth: true, type: 'profile' },
  },
  {
    path: '/profile/education',
    name: 'profile-education',
    component: ProfilePage,
    meta: { requiresAuth: true, type: 'profile' },
  },
  {
    path: '/profile/teaching',
    name: 'profile-teaching',
    component: ProfilePage,
    meta: { requiresAuth: true, type: 'profile' },
  },
  {
    path: '/profile/research',
    name: 'profile-research',
    component: ProfilePage,
    meta: { requiresAuth: true, type: 'profile' },
  },
  {
    path: '/profile/student-research',
    name: 'profile-student-research',
    component: ProfilePage,
    meta: { requiresAuth: true, type: 'profile' },
  },
  {
    path: '/profile/projects',
    name: 'profile-projects',
    component: ProfilePage,
    meta: { requiresAuth: true, type: 'profile' },
  },
  {
    path: '/profile/volunteering',
    name: 'profile-volunteering',
    component: ProfilePage,
    meta: { requiresAuth: true, type: 'profile' },
  },
  {
    path: '/profile/mentions',
    name: 'profile-mentions',
    component: ProfilePage,
    meta: { requiresAuth: true, type: 'profile' },
  },
];
